import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TimeCalendarComponent } from "./time-calendar/time-calendar.component";
import { CustomPipesModule } from "../pipes/custom-pipes.module";
import { DateNavComponent } from "./date-nav/date-nav.component";
import { TimersComponent } from "./timers/timers.component";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CustomDiretivesModule } from "../directives/custom-diretives.module";
import { CalendarDayComponent } from "./time-calendar/calendar-day/calendar-day.component";
import { CalendarDayDetailsComponent } from "./time-calendar/calendar-day-details/calendar-day-details.component";
import { CalendarDayEditComponent } from "./time-calendar/calendar-day-edit/calendar-day-edit.component";
import { NgxMaskModule } from "ngx-mask";

@NgModule({
  declarations: [
    TimeCalendarComponent,
    DateNavComponent,
    TimersComponent,
    CalendarDayComponent,
    CalendarDayDetailsComponent,
    CalendarDayEditComponent,
  ],
  imports: [
    CommonModule,
    CustomPipesModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    CustomDiretivesModule,
    NgxMaskModule.forRoot(),
  ], // with ngbmodule in here, it will now be included everywhere. should this be broken up more?
  exports: [TimeCalendarComponent, DateNavComponent, TimersComponent],
})
export class SharedComponentsModule {}
